export const rootPath = '/ticket';
export const createPath = `${rootPath}/create`;
export const filesPath = '/files';
export const receiversPath = '/receivers';
export const viewPath = `${rootPath}/view`;
export const relocatePath = '/relocate';
export const resourcePath = `${rootPath}/resources`;
export const tagPath = `${resourcePath}/tags`;

export const legacyLookupPath = `${rootPath}/legacy-lookup`;

export function getTicketPath(ticketId) {
  return `${viewPath}/${ticketId}`;
}

export function getRelocatePath(ticketId) {
  return `${getTicketPath(ticketId)}${relocatePath}`;
}

export function getFilesPath(ticketId) {
  return `${getTicketPath(ticketId)}${filesPath}`;
}

export function getReceiversPath(ticketId) {
  return `${getTicketPath(ticketId)}${receiversPath}`;
}

export function getTicketSubjectPath(buildingId, unitId, tenantId) {
  const searchParams = new URLSearchParams();
  if (buildingId) searchParams.set('building_id', buildingId);
  if (unitId) searchParams.set('unit_id', unitId);
  if (tenantId) searchParams.set('tenant_id', tenantId);
  return `${createPath}?${searchParams.toString()}`;
}
